import { render } from "./UserAccessibilityDropdown.vue?vue&type=template&id=808a7660"
import script from "./UserAccessibilityDropdown.vue?vue&type=script&lang=js"
export * from "./UserAccessibilityDropdown.vue?vue&type=script&lang=js"

import "./UserAccessibilityDropdown.vue?vue&type=style&index=0&id=808a7660&lang=scss"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__